import { renderMainLeftCell, renderSoftLeftCell, renderSectionHeader, renderRowGaps, renderPercentRow } from '../helpers';
import { textBold } from '../download-data-styles';

export const renderEquitiesBreakdownHeaderRow = (header, asOfDate) => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(header, textBold);
  rowString += renderSoftLeftCell(asOfDate);
  rowString += `</tr>`;
  return rowString;
};

export const equitiesBreakdownModule = data => {
  let moduleString = ``;
  moduleString += renderSectionHeader('Equities Breakdown');
  moduleString += renderRowGaps(3);
  moduleString += renderEquitiesBreakdownHeaderRow('Sectors', data.sectorsAsOfDate);
  data.sectorsData.data.forEach(sector => { moduleString += renderPercentRow(sector.name, sector.value); });
  moduleString += renderRowGaps(2);
  moduleString += renderEquitiesBreakdownHeaderRow('Top Industries', data.topIndustriesAsOfDate);
  moduleString += renderRowGaps();
  if (data.topIndustries.data.length) {
    data.topIndustries.data.forEach(industry => {
      moduleString += renderPercentRow(industry.SubTypeName, industry.DataValue);
    });
  } else {
    moduleString += `<tr>`;
    moduleString += renderMainLeftCell('No top industries data is available at this time.');
    moduleString += `</tr>`;
  }
  moduleString += renderRowGaps(2);
  moduleString += renderEquitiesBreakdownHeaderRow(data.topEquitiesHeader, data.topIndustriesAsOfDate);
  moduleString += renderRowGaps(2);
  if (data.topEquities.length) {
    data.topEquities.forEach(equity => {
      moduleString += renderPercentRow(equity.SubTypeName, equity.DataValue);
    });
  } else {
    moduleString += `<tr>`;
    moduleString += renderMainLeftCell('No equities data is available at this time.');
    moduleString += `</tr>`;
  }
  moduleString += renderRowGaps(2);
  return moduleString;
};
